<template>
  <div class="question-wrap flex-column">
    <div class="flex-item">
      <div class="flex-row content-box" v-if="!mainTarget || !mainType">
        <div class="label">安装人</div>
        <div class="input-box flex-item">
          <input type="" maxlength="11" name="" v-model="fitMan" />
        </div>
      </div>
      <div class="flex-row content-box" v-if="!mainTarget || !mainType">
        <div class="label">安装电话</div>
        <div class="input-box flex-item">
          <input
            @keyup="changePhone($event, 1)"
            type=""
            maxlength="11"
            name=""
            v-model="fitMobile"
          />
        </div>
      </div>
      <div class="question-item" v-for="(item, index) in questionLists">
        <div class="flex-row content-box" v-if="item.queType == 3">
          <div class="label">{{ item.queDesc }}</div>
          <img
            v-if="item.queImagePath"
            :src="imgUrl + '/' + item.queImagePath"
          />
          <div class="input-box flex-item">
            <input
              type=""
              name=""
              v-model="answers && answers[index] && answers[index].optText"
            />
          </div>
        </div>
        <div class="content-box" v-if="item.queType == 5">
          <div class="label">{{ item.queDesc }}</div>
          <img
            v-if="item.queImagePath"
            :src="imgUrl + '/' + item.queImagePath"
          />
          <div class="input-box">
            <textarea
              v-model="answers && answers[index] && answers[index].optText"
            ></textarea>
          </div>
        </div>
        <div class="content-box" v-if="item.queType == 2">
          <div class="label">{{ item.queDesc }}</div>
          <img
            v-if="item.queImagePath"
            :src="imgUrl + '/' + item.queImagePath"
          />
          <div class="input-box">
            <!-- <mu-checkbox @change="change($event,index,option.optId)" v-for="option in item.options" :key="option.optId" :nativeValue="option.optId" :name="index" :label="option.optDesc" class="option-checkbox"/> -->
            <label
              class="check-box"
              v-for="option in item.options"
              :key="option.optId"
            >
              <input
                class="optInput"
                @change="change($event, index, option.optId)"
                type="checkbox"
                :name="index"
              />
              <span class="optLabel">{{ option.optDesc }}</span>
              <img
                class="optImg"
                v-if="option.optImagePath"
                :src="imgUrl + '/' + option.optImagePath"
              />
            </label>
          </div>
        </div>
        <div class="content-box" v-if="item.queType == 1">
          <div class="label">{{ item.queDesc }}</div>
          <img
            v-if="item.queImagePath"
            :src="imgUrl + '/' + item.queImagePath"
          />
          <div class="input-box">
            <!-- <mu-radio v-for="option in item.options" :key="option.optId" :label="option.optDesc" :name="index" :nativeValue="option.optId" v-model="answers && answers[index] && answers[index].optId" class="option-radio"/> -->
            <label
              class="check-box"
              v-for="option in item.options"
              :key="option.optId"
            >
              <input
                class="optInput"
                v-model="answers && answers[index] && answers[index].optId"
                type="radio"
                :name="index"
                :value="option.optId"
              />
              <span class="optLabel">{{ option.optDesc }}</span>
              <img
                class="optImg"
                v-if="option.optImagePath"
                :src="imgUrl + '/' + option.optImagePath"
              />
            </label>
          </div>
        </div>
        <div class="img-box content-box" v-if="item.queType == 4">
          <div class="flex-row">
            <label class="flex-item">{{ item.queDesc }}</label>
            <img
              v-if="item.queImagePath"
              :src="imgUrl + '/' + item.queImagePath"
            />
            <div class="img-item add">
              添加照片
              <input
                @change="canvasSelImg($event, index)"
                type="file"
                class="file-button"
                multiple
                ref="img1"
                accept="image/gif,image/jpeg,image/jpg,image/png"
                value=""
              />
            </div>
          </div>
          <!-- 图片列表 -->
          <div class="image-list" v-for="item in getAttachs(index)">
            <div class="verticalM image-box">
              <img :src="item.fileUrl" class="verticalM-box" />
            </div>
            <label
              class="delete"
              @click="deleteImg(item.attach_Id, index)"
            ></label>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-row">
      <div
        class="flex-item btn"
        v-if="mainTarget && mainType"
        @click="initPriceMainFn"
      >
        去商城
      </div>
      <div class="flex-item btn submitBtn" @click="submitFn">提交</div>
    </div>
    <mu-toast
      v-if="toast.isShow"
      :message="toast.messageTip"
      class="custom-toast"
    />
    <mu-dialog :open="dialog" title="登录" dialogClass="authCodeDialog">
      <div class="flex-row auth-info">
        <label class="label">图片验证码</label>
        <div class="flex-item input-box">
          <input maxlength="4" type="" name="randomCode" v-model="randomCode" />
        </div>
        <div class="codeBtn" style="background: #fff">
          <span class="img-code-box">
            <img :src="randomCodePath" @click="refreshImgCode" />
          </span>
        </div>
      </div>

      <div class="flex-row auth-info">
        <label class="label">手机号</label>
        <div class="flex-item input-box">
          <input
            @keyup="changePhone($event, 2)"
            maxlength="11"
            type=""
            name=""
            v-model="mobile"
            :readonly="isReadonly"
          />
        </div>
        <div
          class="codeBtn"
          :class="{ disabled: isDisabled }"
          @click="getAuthCode"
        >
          {{ codeTitle }}
        </div>
      </div>
      <div class="flex-row auth-info">
        <label class="label">短信验证码</label>
        <div class="flex-item input-box">
          <input
            type=""
            name=""
            v-model="authCode"
            placeholder="请输入验证码"
          />
        </div>
      </div>
      <div class="flex-row buttons">
        <a href="/" class="flex-item button">去商城</a>
        <div class="flex-item button loginBtn" @click="loginCode">登录</div>
      </div>
    </mu-dialog>
  </div>
</template>
<script type="text/javascript ">
import Constant from "@/Constant";
import util from "@common/utils/util";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      dialog: true,
      checkedLists: [],
      questionLists: [],
      paperId: "",
      actionUrl: Constant.uploadBaseUrl + "/apps", //提交URL
      imgUrl: Constant.imgBaseUrl,
      answers: [],
      toast: {
        isShow: false,
        messageTip: "",
      },
      mobile: "",
      orderId: "",
      authCode: "",
      codeTitle: "获取验证码",
      time: 120,
      timmer: "",
      isDisabled: false,
      token: "",
      mainTarget: "",
      mainType: "",
      isReadonly: false,
      fitMobile: "",
      fitMan: "",

      randomCodePath: "",
      randomCode: "",
    };
  },
  created() {
    this.userAttrId = util.storage.session.get("userAttrId");
    this.randomCodePath =
      Constant.imgBaseUrl +
      "/random?v=" +
      Math.random() +
      "&userAttrId=" +
      this.userAttrId;
  },
  mounted() {
    this.mobile = this.$route.query.mobile || "";
    this.isReadonly = !this.mobile ? false : true;
    this.orderId = this.$route.query.orderId || "";
    this.mainTarget = this.$route.query.mainTarget || "";
    this.mainType = this.$route.query.mainType || "";
    if (this.mainTarget && this.mainType) {
      this.dialog = false;
    }
    this.loadData();
  },
  computed: {
    phone() {
      let phone = "";
      if (this.mobile) {
        phone =
          this.mobile.substring(0, 4) + "****" + this.mobile.substring(7, 11);
      }

      return phone;
    },
  },
  methods: {
    ...mapActions({
      getPaperByCode: "getPaperByCode", //获取问卷内容
      commitPaper: "commitPaper", //保存问卷调查的内容
      commitPaperArea: "commitPaperArea", //保存大区内容
      sendAuthCodeSms: "sendAuthCodeSms", //获取验证码
      checkSmsCode: "checkSmsCode", //手机号验证
      initPriceMain: "initPriceMain", //初始化大区价格
    }),

    //刷新图片验证码
    refreshImgCode() {
      this.userAttrId = util.storage.session.get("userAttrId");
      this.randomCodePath =
        Constant.imgBaseUrl +
        "/random?v=" +
        Math.random() +
        "&userAttrId=" +
        this.userAttrId;
    },

    changePhone(e, type) {
      var reg = /[^\d|]/g;
      if (!util.isNum(e.key)) {
        if (type == 1) {
          this.fitMobile = this.fitMobile.replace(e.key, "");
          this.fitMobile = this.fitMobile.replace(reg, "");
        } else if (type == 2) {
          this.mobile = this.mobile.replace(e.key, "");
          this.mobile = this.mobile.replace(reg, "");
        }
      }
    },

    getAnswers() {
      let lists = [];
      if (this.questionLists && this.questionLists.length) {
        this.questionLists.forEach((item) => {
          let obj = {};
          obj.queId = item.queId;
          switch (item.queType) {
            case 1:
              obj.label = "radio";
              obj.optId = "";
              break;
            case 2:
              obj.optIds = [];
              break;
            case 3:
              obj.optText = "";
              break;
            case 4:
              obj.attachs = [];
              break;
          }
          lists.push(obj);
        });
      }
      return lists;
    },
    loadData() {
      let data = {
        paperCode:
          this.mainTarget && this.mainType
            ? "priceMainPaper"
            : "orderServicePaper",
      };
      this.getPaperByCode(data).then((res) => {
        this.questionLists = res.simQuestions;
        this.paperId = res.paperId;
        this.answers = this.getAnswers();
        document.title = res.paperName;
      });
    },
    getAttachs(index) {
      return (
        this.answers &&
        this.answers.length &&
        this.answers[index] &&
        this.answers[index].attachs
      );
    },
    submitFn() {
      if (!this.fitMobile && !this.mainType && !this.mainTarget) {
        this.showTipMessage(true, "安装电话不能为空！");
        return;
      } else if (!this.fitMan && !this.mainType && !this.mainTarget) {
        this.showTipMessage(true, "安装人不能为空！");
        return;
      }
      let dataInfo = {
        paperId: this.paperId,
        simAnswers: "",
      };
      dataInfo.simAnswers = util.deepCopy(this.answers);
      dataInfo.mobile = this.mobile;
      dataInfo.simAnswers.forEach((item) => {
        if (item.label) {
          item.optIds = [];
          if (item.optId) {
            item.optIds.push(item.optId);
          }
        }
      });
      dataInfo.orderId = this.orderId || "";
      dataInfo.fitMobile = this.fitMobile;
      dataInfo.fitMan = this.fitMan;
      let data = {
        data: dataInfo,
        token: this.token,
      };
      if (this.mainTarget && this.mainType) {
        data.data.mainId = this.$route.query["mainId"] || "";
        this.commitPaperArea(data)
          .then((res) => {
            if (res.code == 200) {
              if (this.mainTarget && this.mainType) {
                this.initPriceMainFn();
                return;
              }
              this.$router.push({
                path: "/",
              });
            } else {
              this.showTipMessage(true, "提交失败");
            }
          })
          .catch((error) => {
            this.showTipMessage(true, error || "提交失败");
          });
        return;
      }
      this.commitPaper(data)
        .then((res) => {
          if (res.code == 200) {
            if (this.mainTarget && this.mainType) {
              this.initPriceMainFn();
              return;
            }
            this.$router.push({
              path: "/",
            });
          } else {
            this.showTipMessage(true, "提交失败");
          }
        })
        .catch((error) => {
          this.showTipMessage(true, error || "提交失败");
        });
    },

    initPriceMainFn() {
      let priceMain = {
        mainType: this.mainType,
        mainTarget: this.mainTarget,
      };
      this.initPriceMain([priceMain]).then((res) => {
        this.$router.push({
          path: "/",
        });
      });
    },
    change(e, index, id) {
      console.log(index);
      let checkedLists = this.answers[index].optIds;
      console.log(e);
      if (checkedLists && checkedLists.length) {
        if (e.target.checked) {
          checkedLists.push(id);
        } else {
          checkedLists = checkedLists.filter((item) => {
            return item != id;
          });
        }
      } else {
        checkedLists.push(id);
      }

      let obj = this.answers[index];
      obj.optIds = checkedLists;
      this.$set(this.answers, index, obj);
    },

    //删除图片
    deleteImg(id, index) {
      let obj = this.answers[index];
      obj.attachs = obj.attachs.filter((item) => {
        return item.attach_Id != id;
      });

      this.$set(this.answers, index, obj);
    },

    /*提示信息*/
    showTipMessage(isShow, msg) {
      this.toast.isShow = isShow;
      this.toast.messageTip = msg;
      setTimeout(() => {
        this.toast.isShow = false;
      }, 1500);
    },

    //图片压缩
    canvasSelImg(event, index) {
      let _this = this;
      var file = event.target.files[0];
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      let str = "JPG/JPEG/PNG/GIF";
      let errorImgMsg = "文件格式只能是:jpg、png、jpeg、gif";
      if (str.indexOf(testmsg.toUpperCase()) < 0) {
        this.showTipMessage(true, errorImgMsg);
        return;
      }

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        var oReader = new FileReader();
        oReader.onload = function (e) {
          var image = new Image();
          image.src = e.target.result;
          util.imgScale(e.target.result, file, 4).then((result) => {
            util
              .canvasUpload(_this.actionUrl, result, file)
              .then((res) => {
                event.target.value = "";
                if (!res.returnTargets[0].fileId) {
                  _this.showTipMessage(true, "上传失败");
                  return;
                }
                _this.showTipMessage(true, "上传成功");
                res.returnTargets[0].fileName =
                  Constant.imgBaseUrl +
                  "/image/" +
                  res.returnTargets[0].fileName;

                let oldData = _this.answers;

                //存储上传的文件
                let obj = Object.assign({}, oldData[index]);
                let lists = [];
                lists.push({
                  attachId: res.returnTargets[0].fileId,
                  fileUrl: res.returnTargets[0].fileName,
                });

                obj.attachs = obj.attachs.concat(lists);
                _this.$set(_this.answers, index, obj);
              })
              .catch((err) => {
                event.target.value = "";
                this.showTipMessage(true, err || "上传失败");
              });
          });
        };
        oReader.readAsDataURL(file);
      };
    },

    //获取验证码
    getAuthCode() {
      if (this.isDisabled) {
        return;
      }
      if (!this.mobile) {
        this.showTipMessage(true, "请输入手机号！");
        return;
      }

      if (!this.randomCode) {
        this.showTipMessage(true, "请输入图片验证码");
        return;
      }

      let _this = this;

      this.sendAuthCodeSms([this.mobile, this.randomCode]).then((res) => {
        if (res.success) {
          this.timmer = setInterval(function () {
            _this.codeTitle = _this.time + "s后获取";
            _this.isDisabled = true;
            _this.time--;
            if (_this.time == 0) {
              _this.codeTitle = "获取验证码";
              _this.isDisabled = false;
              clearInterval(_this.timmer);
            }
          }, 1000);
        }
      });
    },
    loginCode() {
      if (!this.mobile) {
        this.showTipMessage(true, "手机号码不能为空！");
        return;
      } else if (!this.authCode) {
        this.showTipMessage(true, "验证码不能为空！");
        return;
      }
      let data = {
        mobile: this.mobile,
        authCode: this.authCode,
      };
      this.checkSmsCode([this.mobile, this.authCode])
        .then((res) => {
          if (res.success) {
            this.dialog = false;
            this.token = res.target.token;
          } else {
            this.showTipMessage(true, "验证失败");
          }
        })
        .catch((error) => {
          this.showTipMessage(true, error || "验证失败");
        });
    },
  },
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import "src/common/sass/mixin";
.question-wrap {
  .btn {
    @include font-dpr(16px);
    color: #4a4a4a;
    text-align: center;
    padding: 0.413333rem 0;
    box-shadow: inset 0 1px 0 0 #e5e5e5;
    &.submitBtn {
      background: #3b99fc;
      color: #fff;
    }
  }
  .content-box {
    padding: 0.133333rem 0.4rem;
    position: relative;
    .label {
      width: auto;
      min-width: 2.4rem;
      margin-right: 0.266667rem;
      line-height: 1.066667rem;
      @include font-dpr(16px);
      color: rgba(0, 0, 0, 0.87);
      + img {
        width: 2.666667rem;
        height: auto;
      }
    }
    .input-box {
      > input {
        width: 100%;
        height: 1.066667rem;
        text-indent: 0.16rem;
        border: 1px solid #cfcfcf;
        border-radius: 0.053333rem;
        @include font-dpr(16px);
      }
      .check-box {
        display: inline-block;
        margin-right: 0.266667rem;
        position: relative;
        padding: 0.266667rem 0;
        > .optLabel {
          display: inline-block;
          vertical-align: middle;
          @include font-dpr(16px);
        }
        > .optInput {
          vertical-align: middle;
          width: 0.426667rem;
          height: 0.426667rem;
        }
        > .optImg {
          width: 0.666667rem;
          height: auto;
          vertical-align: middle;
        }
      }
      > textarea {
        width: 100%;
        height: 2.666667rem;
        border: 1px solid #cfcfcf;
        border-radius: 0.053333rem;
        @include font-dpr(16px);
        outline: none;
        padding: 0.133333rem;
      }
      .option-radio,
      .option-checkbox {
        height: auto;
        line-height: inherit;
        margin-right: 0.266667rem;
        .mu-radio-wrapper,
        .mu-checkbox-wrapper {
          height: 1.066667rem;
          line-height: 1.066667rem;
          .mu-radio-ripple-wrapper,
          .mu-checkbox-ripple-wrapper {
            height: 0.64rem;
            width: 0.64rem;
            top: 0.213333rem;
            left: -0.106667rem;
          }
          .mu-radio-icon,
          .mu-checkbox-icon {
            width: 0.426667rem;
            height: 0.426667rem;
            .mu-radio-svg-icon,
            .mu-checkbox-svg-icon {
              width: 0.426667rem;
              height: 0.426667rem;
            }
          }
        }
        .mu-radio-label,
        .mu-checkbox-label {
          @include font-dpr(16px);
        }
      }
    }
  }
  .img-box {
    @include font-dpr(16px);
    color: rgba(0, 0, 0, 0.87);
    line-height: 0.8rem;
    .img-item {
      width: 2.053333rem;
      height: 0.8rem;
      line-height: 0.8rem;
      position: relative;
      @include font-dpr(14px);
      color: #eb7c06;
      text-align: center;
      background: #ffffff;
      border: 2px solid #eb7c06;
      border-radius: 6px;
      > input {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        opacity: 0;
      }
    }
    .image-list {
      display: inline-block;
      margin-top: 0.266667rem;
      margin-right: 0.4rem;
      position: relative;
      .image-box {
        width: 2.666667rem;
        height: 2rem;
        overflow: hidden;
        > img {
          width: 100%;
          height: 100%;
        }
      }
      .delete {
        display: inline-block;
        width: 0.48rem;
        height: 0.48rem;
        background: url("/static/images/tag_close@3x.png") no-repeat;
        background-size: 100% auto;
        position: absolute;
        right: -0.24rem;
        top: -0.24rem;
        z-index: 11;
      }
    }
  }
}

.authCodeDialog {
  border-radius: 0.106667rem;
  max-width: none;
  .mu-dialog-title {
    display: block;
    @include font-dpr(18px);
    color: #000;
    padding: 0.533333rem 0;
    text-align: center;
  }
  .mu-dialog-body {
    padding: 0;
    @include font-dpr(14px);
    color: #666;
    .auth-info {
      padding: 0 0.466667rem 0 0.466667rem;
      line-height: 0.773333rem;
      margin-bottom: 0.186667rem;
      .label {
        margin-right: 0.4rem;
      }
      .input-box {
        border: 1px solid #979797;
        padding: 0 0.133333rem;
        > input {
          width: 100%;
          height: 0.773333rem;
          display: block;
        }
      }
      .codeBtn {
        margin-left: 0.266667rem;
        width: 2rem;
        height: 0.773333rem;
        line-height: 0.773333rem;
        text-align: center;
        height: 0.8rem;
        border-left: 0;
        color: #fff;
        background: #eb7c06;
        @include font-dpr(12px);
        &.disabled {
          background: #ccc;
        }
      }
    }
    .buttons {
      margin-top: 0.36rem;
      border-top: 1px solid #e5e5e5;
      .button {
        color: #4a4a4a;
        @include font-dpr(18px);
        text-align: center;
        padding: 0.333333rem 0;
        &.loginBtn {
          border-left: 1px solid #e5e5e5;
          color: #02bb00;
        }
      }
    }
  }
  .mu-dialog-actions {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?5bdb28b8